import { render, staticRenderFns } from "./dialogWithId.vue?vue&type=template&id=2fab77e8&scoped=true"
import script from "./dialogWithId.vue?vue&type=script&lang=js"
export * from "./dialogWithId.vue?vue&type=script&lang=js"
import style0 from "./dialogWithId.vue?vue&type=style&index=0&id=2fab77e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab77e8",
  null
  
)

export default component.exports